import axios from 'axios';
import { delay } from 'commercial-sales-shared-component';
import properties from '../properties';
import { createFordStandardError } from './createFordStandardError';

const isTimeout = (axiosError) =>
  axiosError?.message?.toLowerCase()?.includes('timeout');

const isNoResponse = (axiosError) => !axiosError?.response;

const isEmptyResultSetResponse = (axiosError) =>
  axiosError?.response?.data?.message?.code ===
  CUSTOM_AEM_STATUS_MESSAGE_ID.EMPTY_RESULT_SET;

const isNon500Error = (axiosError) => axiosError?.response?.status !== 500;

const containsErrorToRetry = (axiosError, errorsToRetry) => {
  if (errorsToRetry?.length === 0) return false;
  return errorsToRetry.includes(axiosError?.response?.status);
};

const CUSTOM_AEM_STATUS_MESSAGE_ID = {
  TIMEOUT: 'TIMEOUT',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  EMPTY_RESULT_SET: 'EMPTY_RESULT_SET',
};

const generateError = (axiosError, customErrorId) => {
  return {
    message: axiosError.message,
    customErrorCode: customErrorId,
  };
};

export const DEFAULT_RETRY_OPTIONS = {
  timeout: 5000,
  shouldRetryWhenTimeout: true,
  retryWait: [100, 1000],
  responseType: null,
  method: 'get',
  data: null,
  errorsToRetry: [],
};

// TODO: mock the AEMClient from shared component library
export const getWithRetry = async (url, options = {}) => {
  const effectiveOptions = {
    ...DEFAULT_RETRY_OPTIONS,
    ...options,
  };
  const { shouldRetryWhenTimeout, retryWait, errorsToRetry, ...axiosOptions } =
    effectiveOptions;
  const maxTries = retryWait.length + 1;

  let tryCount = 0;
  let error;

  while (tryCount < maxTries) {
    if (tryCount > 0) {
      await delay(retryWait[tryCount - 1]);
    }

    try {
      return url.indexOf(properties.Paths.fpgProxy) > -1 &&
        url.indexOf(properties.Paths.fpgUnauthProxy) < 0
        ? await axios(url, {
            ...axiosOptions,
            withCredentials: true,
          })
        : await axios(url, axiosOptions);
    } catch (err) {
      if (isTimeout(err)) {
        error = generateError(err, CUSTOM_AEM_STATUS_MESSAGE_ID.TIMEOUT);
        if (!shouldRetryWhenTimeout) break;
      } else if (isNoResponse(err)) {
        error = generateError(err, CUSTOM_AEM_STATUS_MESSAGE_ID.UNKNOWN_ERROR);
      } else if (isEmptyResultSetResponse(err)) {
        error = generateError(
          err,
          CUSTOM_AEM_STATUS_MESSAGE_ID.EMPTY_RESULT_SET
        );
      } else {
        error = err;
        if (isNon500Error(err) && !containsErrorToRetry(err, errorsToRetry))
          break;
      }
    }

    const warning = error.response ?? error;

    console.warn(
      `FPT: HTTP error ${warning.status ?? warning}`,
      warning.data ?? warning
    );
    tryCount += 1;
  }

  throw createFordStandardError(
    error.response?.status,
    error.message,
    error.response?.data,
    error.customErrorCode
  );
};
